import { render, staticRenderFns } from "./ThreadInspectActions.vue?vue&type=template&id=49234ab8&"
import script from "./ThreadInspectActions.vue?vue&type=script&lang=js&"
export * from "./ThreadInspectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports